import { OrderStatus, UserAccount } from './index';

/**
 * Model to hold OrderItem details for an Order
 */
export class OrderItem {
    public static PAY_OPTION_ONLINE: string = 'Online';
    public static PAY_OPTION_ON_SITE: string = 'On-site';

    public id: string;
    public productTypeId: string;
    public name: string;
    public quantity: number;
    public onlinePrice: number;
    public onsitePrice: number;
    public status: string;
    public statusReason: string;
    public paymentOptionType: string;
    public entityGuid: string;
    public entityName: string;
    public isEntityDeleted: boolean;
    public subtotal: string;
    public parentId: string;
    public children: OrderItem[] = [];
    public onlineSubtotal: number;
    public onsiteSubtotal: number;
    public onlineAmountPaid: number;
    public createdByUserAccount: UserAccount;

    get isPaid(): boolean {
        return this.status === OrderStatus.PAID;
    }

    get isUnpaid(): boolean {
        return this.status === OrderStatus.UNPAID;
    }

    get isPayOnsite(): boolean {
        return this.status === OrderStatus.PAY_ON_SITE;
    }

    get isInvalid(): boolean {
        return this.status === OrderStatus.INVALID;
    }

    get isRefunded(): boolean {
        return this.status === OrderStatus.REFUNDED;
    }

    get isNA(): boolean {
        return this.status === OrderStatus.NA;
    }

    get price(): number {
        if (this.isPayOnsite) {
            return this.onsitePrice;
        }

        return this.onlinePrice;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: any, included: any[]): OrderItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes;
        const relationships: any = data.relationships || {};
        included = included || [];

        this.id = data.id;
        this.name = attrs.name;
        this.productTypeId = attrs.productTypeId;
        this.quantity = parseInt(attrs.quantity, null);
        this.onlinePrice = parseFloat(attrs.onlinePrice);
        this.onsitePrice = parseFloat(attrs.onsitePrice);
        this.onlineSubtotal = parseFloat(attrs.onlineSubtotal);
        this.onsiteSubtotal = parseFloat(attrs.onsiteSubtotal);
        this.onlineAmountPaid = parseFloat(attrs.onlineAmountPaid);
        this.status = attrs.status;
        this.statusReason = attrs.statusReason;
        this.paymentOptionType = attrs.paymentOptionType;
        this.entityGuid = attrs.entityGuid;
        this.entityName = attrs.entityName;
        this.subtotal = attrs.subtotal;
        this.parentId = attrs.parentId;
        this.isEntityDeleted = attrs.isEntityDeleted;

        // Fill createdByUserAccount from relationships if it exists
        const userAccountRelationship: any = relationships.createdByUserAccount;
        if (userAccountRelationship &&
            included &&
            userAccountRelationship.data &&
            userAccountRelationship.data.id) {
            const userAccountId: string = userAccountRelationship.data.id;
            const userAccountInclude: any = included.filter(
                (i: any) => i.type === 'userAccount' && i.id === userAccountId,
            )[0];

            if (userAccountInclude) {
                this.createdByUserAccount = (new UserAccount()).deserialize(userAccountInclude);
            }
        }

        return this;
    }
}
